module.exports = __webpack_public_path__ + "static/img/bomap.9655657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bomap.png
// module id = 7VUQ
// module chunks = 0